export const calculateAgeOfVehicle = (yearOfManufacture: number) => {
    const currentYear = new Date().getFullYear();
    const age = currentYear - yearOfManufacture;
    return age;
};